import constants from '@/constants'
import store from '@/store'

// Returns { morphType: Number, foreignId: Number } | null
export function parseInternalLink(href) {
  if (!href || typeof href !== 'string') return null

  let url
  try {
    url = new URL(href)
  } catch (e) {
    // Try to prepend protocol for bare links
    try {
      url = new URL(`https://${href}`)
    } catch (e2) {
      return null
    }
  }

  const appDomains = store.getters['auth/config']?.app_domains || []
  if (!appDomains.includes(url.host)) {
    return null
  }

  const path = url.pathname

  // Learning material file: /learningmaterials/:id
  {
    const match = path.match(/^\/learningmaterials\/(\d+)(?:\/?|$)/)
    if (match) {
      return {
        morphType: constants.MORPH_TYPES.TYPE_LEARNINGMATERIAL,
        foreignId: parseInt(match[1], 10),
      }
    }
  }

  // Course: /courses/:courseId, /courses/new/:courseId/... , /courses/preview/:courseId , /courses/:courseId/participation/... (still course morph)
  {
    let match = path.match(/^\/courses\/new\/(\d+)(?:\/|$)/)
    if (!match) match = path.match(/^\/courses\/preview\/(\d+)(?:\/|$)/)
    if (!match) match = path.match(/^\/courses\/(\d+)(?:\/|$)/)
    if (match) {
      return {
        morphType: constants.MORPH_TYPES.TYPE_COURSE,
        foreignId: parseInt(match[1], 10),
      }
    }
  }

  // News: /news/:id
  {
    const match = path.match(/^\/news\/(\d+)(?:\/|$)/)
    if (match) {
      return {
        morphType: constants.MORPH_TYPES.TYPE_NEWS,
        foreignId: parseInt(match[1], 10),
      }
    }
  }

  // Appointment: /appointments/:appointmentId
  {
    const match = path.match(/^\/appointments\/(\d+)(?:\/|$)/)
    if (match) {
      return {
        morphType: constants.MORPH_TYPES.TYPE_APPOINTMENT,
        foreignId: parseInt(match[1], 10),
      }
    }
  }

  // Powerlearning category: /powerlearning/category/:id
  {
    const match = path.match(/^\/powerlearning\/category\/(\d+)(?:\/|$)/)
    if (match) {
      return {
        morphType: constants.MORPH_TYPES.TYPE_CATEGORY,
        foreignId: parseInt(match[1], 10),
      }
    }
  }

  // Quiz battle: /quizzes/:id (TYPE_GAME)
  {
    const match = path.match(/^\/quizzes\/(\d+)(?:\/|$)/)
    if (match) {
      return {
        morphType: constants.MORPH_TYPES.TYPE_GAME,
        foreignId: parseInt(match[1], 10),
      }
    }
  }

  return null
}
